//#region components/motion_text/motion_text_constants.js
var e = [
	"gradient-in",
	"fade-in",
	"slide-in",
	"gradient-sweep",
	"shimmer",
	"none"
], t = [
	"sm",
	"md",
	"lg"
], n = {
	sm: {
		characterDelay: 20,
		wordDelay: 30,
		duration: 600
	},
	md: {
		characterDelay: 30,
		wordDelay: 50,
		duration: 1e3
	},
	lg: {
		characterDelay: 50,
		wordDelay: 100,
		duration: 1500
	}
}, r = {
	MOTION_TEXT_ANIMATION_MODES: e,
	MOTION_TEXT_SPEEDS: t,
	MOTION_TEXT_TIMING_PRESETS: n
};
//#endregion
export { e as MOTION_TEXT_ANIMATION_MODES, t as MOTION_TEXT_SPEEDS, n as MOTION_TEXT_TIMING_PRESETS, r as default };

//# sourceMappingURL=motion-text-constants.js.map